type SectionHeadingProps = {
  index: string;
  title: string;
  desc?: string;
};

export default function SectionHeading({ index, title, desc }: SectionHeadingProps) {
  return (
    <div className="flex max-w-3xl flex-col gap-3">
      <span className="inline-flex items-center gap-2 font-label text-xs tracking-[0.25em] text-primary-700">
        <span className="h-px w-8 bg-primary-400" />
        {index}
      </span>
      <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-4xl">{title}</h2>
      {desc && <p className="text-sm leading-relaxed text-foreground-600 md:text-base">{desc}</p>}
    </div>
  );
}